var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    {
      staticClass: "skeleton-container d-block",
      staticStyle: { "z-index": "10" },
    },
    [
      _vm.isMobile === false
        ? _c(
            "b-row",
            { staticClass: "d-flex justify-content-center mt-4 mb-3" },
            [
              _c("b-skeleton", {
                staticClass: "mr-2",
                attrs: { width: "40px", variant: "light", height: "28px" },
              }),
              _c("b-skeleton", {
                attrs: { width: "300px", variant: "light", height: "28px" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isMobile === false
        ? _c(
            "b-row",
            { staticClass: "no-gutters" },
            [
              _c("b-col", { staticClass: "col-5" }, [
                _c("div", { staticClass: "job-result-list" }, [
                  _c(
                    "ul",
                    _vm._l(_vm.iterateList, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "clickable w-100",
                          class: { active: index === _vm.activePosting },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "result-item p-3" },
                            [
                              index === _vm.activePosting
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "result-item-title" },
                                      [
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "200px",
                                            variant: "light",
                                          },
                                        }),
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100px",
                                            variant: "light",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "result-item-text" },
                                      [
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100%",
                                            variant: "light",
                                          },
                                        }),
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100%",
                                            variant: "light",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "result-item-top d-flex justify-content-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-top-location d-flex",
                                          },
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mr-1",
                                              attrs: {
                                                width: "60px",
                                                variant: "light",
                                              },
                                            }),
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100px",
                                                variant: "light",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-top-date text-brand-medium",
                                          },
                                          [
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100px",
                                                variant: "light",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "result-item-title" },
                                      [
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "200px",
                                            variant: "light",
                                          },
                                        }),
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100px",
                                            variant: "light",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "result-item-text" },
                                      [
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100%",
                                            variant: "light",
                                          },
                                        }),
                                        _c("b-skeleton", {
                                          attrs: {
                                            width: "100%",
                                            variant: "light",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("hr"),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "result-item-top d-flex justify-content-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-top-location d-flex",
                                          },
                                          [
                                            _c("b-skeleton", {
                                              staticClass: "mr-1",
                                              attrs: {
                                                width: "60px",
                                                variant: "light",
                                              },
                                            }),
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100px",
                                                variant: "light",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "item-top-date text-brand-medium",
                                          },
                                          [
                                            _c("b-skeleton", {
                                              attrs: {
                                                width: "100px",
                                                variant: "light",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
              _c("b-col", { staticClass: "col-7" }, [
                _c(
                  "div",
                  { staticClass: "job-details-view p-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c("b-skeleton", {
                          staticClass: "mb-2",
                          attrs: {
                            width: "120px",
                            type: "button",
                            variant: "light",
                          },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "150px", variant: "light" },
                        }),
                      ],
                      1
                    ),
                    _c("hr"),
                    _c(
                      "b-skeleton",
                      { attrs: { width: "90%", variant: "light" } },
                      [
                        _c("b-skeleton", {
                          attrs: { width: "200px", variant: "light" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "item-top-location d-flex" },
                      [
                        _c("b-skeleton", {
                          staticClass: "mr-1",
                          attrs: { width: "60px", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100px", variant: "light" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "result-item-text mt-4" },
                      [
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "50%", variant: "light" },
                        }),
                        _c("br"),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "20%", variant: "light" },
                        }),
                        _c("br"),
                        _c("b-skeleton", {
                          attrs: { width: "60%", variant: "light" },
                        }),
                        _c("br"),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "70%", variant: "light" },
                        }),
                        _c("br"),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "30%", variant: "light" },
                        }),
                        _c("br"),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "100%", variant: "light" },
                        }),
                        _c("b-skeleton", {
                          attrs: { width: "50%", variant: "light" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _c("b-row", { staticClass: "no-gutters" }, [
            _c("div", { staticClass: "job-result-list" }, [
              _c(
                "ul",
                _vm._l(_vm.iterateList, function (item, index) {
                  return _c(
                    "li",
                    { key: index, staticClass: "clickable w-100 p-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "result-item-title" },
                        [
                          _c("b-skeleton", { attrs: { width: "80%" } }),
                          _c("b-skeleton", { attrs: { width: "40%" } }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "result-item-text" },
                        [
                          _c("b-skeleton", { attrs: { width: "90%" } }),
                          _c("b-skeleton", { attrs: { width: "80%" } }),
                        ],
                        1
                      ),
                      _c("hr"),
                      _c(
                        "div",
                        {
                          staticClass:
                            "result-item-top d-flex justify-content-between",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "item-top-location d-flex" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mr-1",
                                attrs: { width: "60px" },
                              }),
                              _c("b-skeleton", { attrs: { width: "100px" } }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "item-top-date text-brand-medium" },
                            [_c("b-skeleton", { attrs: { width: "100px" } })],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }